import React from 'react'

function BulkLocationEditorJobResultsCreateMode({status, jobResults}) {
  return <div>
    <table style={{"width": "100%"}}>
      <tbody>
      {status === "Executing" && <tr>
          <td>Creating new location</td>
          <td style={{"minWidth": "300px"}}>
            <div className="progress">
              <div className="progress-bar progress-bar-striped bg-warning progress-bar-animated" role="progressbar"
    aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{"width": "33%"}} />
            </div>
          </td>
        </tr>
      }
      {status === "Success" && <tr>
          <td>Complete.</td>
          <td style={{"minWidth": "300px"}}>
            <div className="progress">
              <div className="progress-bar progress-bar-striped bg-success" role="progressbar"
    aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style={{"width": "100%"}} />
            </div>
          </td>
        </tr>
      }
      {status === "Failure" && <tr>
          <td>Something went wrong. Please contact support if the issue persists.</td>
          <td style={{"minWidth": "300px"}}>
            <div className="progress">
              <div className="progress-bar progress-bar-striped bg-danger" role="progressbar"
    aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style={{"width": "100%"}} />
            </div>
          </td>
        </tr>
      }
      {(jobResults.failedLocationIdsAndErrors || []).length > 0 && <div className="card-spacer-top"/>}
      {(jobResults.failedLocationIdsAndErrors || []).map((locationIdAndError, index) => {
        const error = locationIdAndError.error;
        return <tr key={"processed-" + index}>
          <td style={{"minWidth": "300px"}}>
            <div className="progress">
              <div className="progress-bar progress-bar-striped bg-danger" role="progressbar"
                   aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{"width": "100%"}} />
            </div>
            <div className="invalid-feedback" style={{"display": "block", "wordWrap": "break-all"}}>
              {error}
            </div>
          </td>
        </tr>
      })}
      </tbody>
    </table>
  </div>
}

export default BulkLocationEditorJobResultsCreateMode